import adminDispatcher from '../action';

const initialState = {
  list: [],
  paging: {
    pageIndex: 0,
    pageSize: 10,
    totalItem: 0,
    totalPage: 0
  },
  listAdminRole: []
};

const adminReducer = adminDispatcher(initialState, {
  [adminDispatcher.getDataSuccess]: (state, payload) => ({
    list: payload.data.list,
    paging: {
      ...payload.data,
      list: undefined
    }
  }),
  [adminDispatcher.setState]: (state, payload) => ({
    [payload.state]: payload.value
  }),
  [adminDispatcher.getAdminRoleSuccess]: (state, payload) => ({
    listAdminRole: payload.data
  })
});

export default adminReducer;
